<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oIuPQu/tc-custom/9781626815445.jpg?1720280502346" alt="This image is the cover for the book Gold as the Morning Sun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gold as the Morning Sun
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning author of <i>Lysette</i> delivers a “well-crafted tale” of Western romance “that will both inspire and pull at your heartstrings” (<i>RT Book Reviews</i>).</b><br/>  <br/> Seeking to ease her ailing father’s mind in his final days, Callie Southgate agrees to marry a mail-order groom coming to Colorado from back east. When she first meets her husband-to-be, she cannot help being timid around the handsome, mysterious man. But when they marry, Callie finds a passion she never knew in his embrace.<br/>  <br/> Con-man and bank robber Jace Greer is given the perfect opportunity to start over when a stagecoach carrying a mail-order groom is ambushed, leaving Callie’s future husband dead. Taking on the deceased man’s identity as his own, Jace continues to the Southgate home with the hope of leaving his sinister past behind him.<br/>  <br/> But as true love blooms between Jace and Callie, secrets Jace tried to keep buried begin to surface, threatening their futures—and their lives. Will Callie be able to see beyond Jace’s transgressions and love him for the man he has become?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sylvia Halliday
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f8fc49c